interface SectionHeadingProps {
  eyebrow: string;
  title: string;
  desc?: string;
  align?: 'left' | 'center';
}

export default function SectionHeading({ eyebrow, title, desc, align = 'left' }: SectionHeadingProps) {
  const isCenter = align === 'center';

  return (
    <div className={isCenter ? 'mx-auto max-w-2xl text-center' : 'max-w-2xl'}>
      <div className={`flex items-center gap-2 ${isCenter ? 'justify-center' : ''}`}>
        <span className="h-4 w-1 rounded-full bg-primary-500" />
        <span className="font-label text-xs font-medium tracking-widest text-primary-600">{eyebrow}</span>
      </div>
      <h3 className="mt-3 font-heading text-2xl font-bold leading-snug text-foreground-950 md:text-3xl">{title}</h3>
      {desc && <p className="mt-3 text-sm leading-relaxed text-foreground-600 md:text-base">{desc}</p>}
    </div>
  );
}